import { HttpClient } from '@angular/common/http';
import { Component, inject, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NeedHelpVm } from '../../shared/generated/Support/Models/NeedHelpVm';
import { SecurityService } from '../security/security.service';

@Component({
    selector: 'pcg-need-help',
    templateUrl: './need-help.component.html',
    styleUrls: ['./need-help.component.scss'],
    standalone: false,
})
export class NeedHelpComponent {
    private http = inject(HttpClient);
    private router = inject(Router);
    private modalService = inject(NgbModal);
    private sec = inject(SecurityService);

    @ViewChild('needHelpModal', { static: true })
    needHelpModal!: TemplateRef<any>;

    needHelp?: NeedHelpVm;
    loading = false;

    // Shown to every logged-in user regardless of status or permission level.
    get isVisible() {
        return this.sec.isLoggedOn();
    }

    open() {
        this.loading = true;
        this.needHelp = undefined;
        this.modalService.open(this.needHelpModal, { centered: true });
        this.http
            .get<NeedHelpVm>('api/Support/SupportNeedHelp/GetNeedHelp')
            .subscribe(
                (vm) => {
                    this.needHelp = vm;
                    this.loading = false;
                },
                () => (this.loading = false)
            );
    }

    goToSupport() {
        this.modalService.dismissAll();
        this.router.navigateByUrl('/support/list');
    }

    createTicket() {
        this.modalService.dismissAll();
        this.router.navigateByUrl('/support/ticket/0');
    }
}
